import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ICaseDocComment, ICaseDocument, ICaseDocumentRequestBody, ICaseSearchRequestBody, IJudge, IMotionCaseNumber, IMotionCasenumberParams, ISearchRequestParams, ITrialPanelJudgesRequest } from "../models/case-assignment.model";
import { IResponse } from "@app/lib/models/response.model";

@Injectable({
    providedIn: 'root'
})
export class CaseDocumentService extends BaseHttpService {

    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
    }

    /**
     * get lsit of Motion Case numbers dropdown with case number
     * @param queryParams 
     */
    getMotionCaseNumbers(queryParams: IMotionCasenumberParams) {
        return this.get<{ success: IMotionCaseNumber[] }>('case/motions.htm', { params: { ...queryParams } });
        // return this.get<IResponse<IMotionCaseNumber[]>>('case/motions.htm', { params: { ...queryParams } });
    }

    getCaseFilesByMotionCase(reqBody: ICaseDocumentRequestBody, queryParams: ISearchRequestParams) {
        return this.post<IResponse<ICaseDocument[]>, ICaseDocumentRequestBody>('case/files.htm', reqBody, { params: { ...queryParams } });
    }
    
    getCaseComments(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams) {
        return this.post<IResponse<ICaseDocComment[]>, ICaseSearchRequestBody>('case/comments.htm', reqBody, { params: { ...queryParams } });
    }

    getTrialPanelJudges(reqBody: ITrialPanelJudgesRequest,queryParams: ISearchRequestParams) {
    return this.post<IResponse<IJudge[]>, ITrialPanelJudgesRequest>( 'case-phase/trial-panel-judges.htm',reqBody,{ params: { ...queryParams } });
   }


}